/* src/app/components/lead-details/participant-information/lead-detail-participant-info/lead-detail-participant-info.component.css */
.nz-padding-left {
  padding-left: 1rem;
}
.height-input-container {
  display: flex;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
}
.ant-picker {
  padding: 0 8px;
  width: 100%;
}
.ant-picker .ant-picker-input {
  border: 2px solid orange !important;
  border-radius: 10%;
}
.ant-picker .ant-picker-input input {
  border: 2px solid red !important;
  border-radius: 10%;
}
.ppl-mt20 {
  margin-top: 20px;
}
.nz-form .ant-form-item {
  display: flex;
  align-items: center;
}
.nz-form .ant-form-item-control {
  flex: 1;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
::ng-deep nz-input-group > .ant-input {
  height: 25px;
}
.custom-row {
  display: flex;
  justify-content: flex-end;
}
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
}
.ant-radio-group {
  display: block;
  align-items: left !important;
}
.ant-radio-button-wrapper {
  width: 122px !important;
}
.ant-error {
  color: #ff4d4f;
}
/*# sourceMappingURL=lead-detail-participant-info.component-XDXRKNUZ.css.map */
